import * as schema from "yup";
import { ConnectedAccountModel } from "@/modules/integrationSettings/shared/models/integrationSettings";

export const formSchema = schema.object<Partial<Record<keyof ConnectedAccountModel, schema.AnySchema>>>({
  companyName: schema.string().trim().required("Company name is required"),
  user: schema.object({
    name: schema.string().trim().required("Last name is required").min(1, "Last name is required"),
    email: schema.string().trim().email("Invalid email").required("Email is required").min(1, "Email is required"),
    firstName: schema.string().trim().required("First name is required").min(1, "First name is required"),
  }),
  sites: schema.array().when("$shouldValidateSites", {
    is: true,
    then: schema
      .array()
      .of(
        schema.object({
          id: schema.string().required(),
          name: schema.string().required(),
        })
      )
      .min(1, "Site is required")
      .required("Site is required"),
    otherwise: schema.array().notRequired(),
  }),
});
